export const gSeqTypeEnum = Object.freeze({
  sequence: 'Sequence',
  loop: 'Loop',
  forever: 'Forever'
});
